.btn-delete-connection{margin-top:-6px;margin-right:-11px}.v-line{height:25px;width:1px;background-color:#e2e2e2}
/*# sourceMappingURL=sip-config-form.component-7RH5D7HB.css.map */
